<div class="rank-icon-container">
    <svg *ngIf="shouldShowIcon" class="mb-2 rank-icon">
        <use [attr.href]="rankIcon"></use>
    </svg>
    <p class="formatted-value" *ngIf="!shouldShowIcon">{{rank}}</p>
</div>